"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.i18nNameSpace = exports.BLOCK_FORMAT_NODES = exports.BLOCK_FORMATS = exports.hsformattingConfig = exports.FONT_SIZE_BLOCKS = exports.FORMAT_COMMAND_TO_INHERITED_COMMAND = exports.INHERITED_UNDERLINE_FORMAT = exports.INHERITED_ITALIC_FORMAT = exports.INHERITED_BOLD_FORMAT = exports.BLOCK_FONT_SIZE_FORMAT = exports.LINE_HEIGHT_FORMAT = exports.BLOCK_FONT_SIZE_GATE = void 0;
var BLOCK_FONT_SIZE_GATE = 'tinymce_use_block_fontsize';
exports.BLOCK_FONT_SIZE_GATE = BLOCK_FONT_SIZE_GATE;
var LINE_HEIGHT_FORMAT = 'line_height';
exports.LINE_HEIGHT_FORMAT = LINE_HEIGHT_FORMAT;
var BLOCK_FONT_SIZE_FORMAT = 'block_font_size';
exports.BLOCK_FONT_SIZE_FORMAT = BLOCK_FONT_SIZE_FORMAT;
var INHERITED_BOLD_FORMAT = 'inherited_bold';
exports.INHERITED_BOLD_FORMAT = INHERITED_BOLD_FORMAT;
var INHERITED_ITALIC_FORMAT = 'inherited_italic';
exports.INHERITED_ITALIC_FORMAT = INHERITED_ITALIC_FORMAT;
var INHERITED_UNDERLINE_FORMAT = 'inherited_underline';
exports.INHERITED_UNDERLINE_FORMAT = INHERITED_UNDERLINE_FORMAT;

var createOverrideFormatCommands = function createOverrideFormatCommands(format) {
  return {
    on: format + "_enabled",
    off: format + "_disabled"
  };
};

var FORMAT_COMMAND_TO_INHERITED_COMMAND = {
  bold: createOverrideFormatCommands(INHERITED_BOLD_FORMAT),
  italic: createOverrideFormatCommands(INHERITED_ITALIC_FORMAT),
  underline: createOverrideFormatCommands(INHERITED_UNDERLINE_FORMAT)
};
exports.FORMAT_COMMAND_TO_INHERITED_COMMAND = FORMAT_COMMAND_TO_INHERITED_COMMAND;
var FONT_SIZE_BLOCKS = ['p', 'blockquote', 'ul', 'ol', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'div'];
exports.FONT_SIZE_BLOCKS = FONT_SIZE_BLOCKS;
var hsformattingConfig = {
  WEBFONT_FORMATS: 'webfont_formats',
  FONT_FORMATS: 'font_formats_v2',
  FONT_SIZE_FORMATS: 'fontsize_formats_v2',
  LINE_HEIGHTS: 'line_heights',
  BLOCK_FORMATS: 'block_formats',
  APPLY_LINE_HEIGHT_PERCENTAGE: 'apply_lineheight_percentage',
  OVERRIDE_INHERITED_STYLES_CONFIG: 'override_inherited_styles_config',
  KEYBOARD_ESCAPE_FORMATS: 'keyboard_escape_formats'
};
exports.hsformattingConfig = hsformattingConfig;
var BLOCK_FORMATS = [{
  title: 'Heading 1',
  format: 'h1'
}, {
  title: 'Heading 2',
  format: 'h2'
}, {
  title: 'Heading 3',
  format: 'h3'
}, {
  title: 'Heading 4',
  format: 'h4'
}, {
  title: 'Heading 5',
  format: 'h5'
}, {
  title: 'Heading 6',
  format: 'h6'
}, {
  title: 'Paragraph',
  format: 'p'
}, {
  title: 'Blockquote',
  format: 'blockquote'
}, {
  title: 'Div',
  format: 'div'
}, {
  title: 'Pre',
  format: 'pre'
}];
exports.BLOCK_FORMATS = BLOCK_FORMATS;
var BLOCK_FORMAT_NODES = BLOCK_FORMATS.map(function (b) {
  return b.format;
});
exports.BLOCK_FORMAT_NODES = BLOCK_FORMAT_NODES;
var i18nNameSpace = 'TinymcePlugins.hsformatting';
exports.i18nNameSpace = i18nNameSpace;